import React, { useState, useEffect, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Footer from "./Footer";
import "./Payment.css";
import CommonPopup from "./CommonPopup";
import useInactivityRedirect from "./useInactivityRedirect";

const MONTH_OPTIONS = [1, 2, 3, 4, 5, 6];
const WEEK_OPTIONS = [1, 2, 3, 4, 5, 6];
const successCodes = ["0000", "3001", "A000", "KP00", "NP00", "PP00", "LP00", "PI00", "4100", "4110"];

const Payment = () => {
  const { t } = useTranslation("payment");
  const navigate = useNavigate();
  const location = useLocation();

useEffect(() => {
  const params = new URLSearchParams(window.location.search);
  const cancel = params.get("cancel");

  if (cancel === "1") {
    const isMobile = /iphone|ipad|android|blackberry|windows ce|iemobile|opera mini|mobile/i.test(navigator.userAgent);
    navigate(isMobile ? -3 : -2);
  }
}, []);

  const { mainCode: locationMainCode, lockerNo: locationLockerNo } = location.state || {};

  const mainCode = location.state?.mainCode || sessionStorage.getItem("mainCode");
  const lockerNo = location.state?.lockerNo || sessionStorage.getItem("lockerNo");

  const [type, setType] = useState("일반결제");
  const [availableTypes, setAvailableTypes] = useState(["일반결제"]);
  const [months, setMonths] = useState(1);
  const [weeks, setWeeks] = useState(1);
  const [selectedMethod, setSelectedMethod] = useState("");
  const [endTime, setEndTime] = useState("");
  const [cost, setCost] = useState(0);
  const [feeData, setFeeData] = useState(null);
  const [tmpLang, setTmpLang] = useState("KR");
  const [sdkLoaded, setSdkLoaded] = useState(false);
  const [encryptData, setEncryptData] = useState("");
  const [startTime, setStartTime] = useState("");
  const [ediDate, setEdiDate] = useState("");
  const [Mid, setMid] = useState("");
  const [LogId_unitCode, LogId_lockerNo] = useState("");

  const {
    showPopup,
    confirmRedirect,
    cancelRedirect,
    remainingSeconds,
  } = useInactivityRedirect({
    inactivityTimeout:  60 * 1000,
    popupTimeout: 15 * 1000,
    redirectTo: "/",
  });

const getKSTDate = () => {
  const now = new Date();
  const utc = now.getTime() + now.getTimezoneOffset() * 60 * 1000;
  return new Date(utc + 9 * 60 * 60 * 1000);
};

  useEffect(() => {
    const sessionUnitCode = sessionStorage.getItem("UNITCODE");
    const sessionMainCode = sessionStorage.getItem("mainCode");
    const sessionLockerNo = sessionStorage.getItem("lockerNo");

    if (!sessionUnitCode || !sessionMainCode || !sessionLockerNo || sessionLockerNo === "0") {
      alert("잘못된 접근입니다.");
      navigate("/");
    }
  }, [navigate]);

  const PAYMENT_METHODS = [
	{ label: t("card"), value: "CARD" },
	  // { label: t("cellphone_payment"), value: "CELLPHONE" },
  ];

  const getLogId = () => {
	 const LogId_unitCode = sessionStorage.getItem("UNITCODE") || locationMainCode;
	 const LogId_lockerNo = sessionStorage.getItem("lockerNo") || locationLockerNo;
	 const now = new Date();
	 const timestamp = now.toISOString().replace(/[-T:Z.]/g, "").slice(0, 14);		//yyyyMMddHHmmss
	 return `${LogId_unitCode}_${(LogId_lockerNo || "").toString().padStart(3, '0')}_${timestamp}`;
  };

  const logId = getLogId();
  sessionStorage.setItem("logId", logId);

  const isMobile = /iphone|ipad|android|blackberry|windows ce|iemobile|opera mini|mobile/i.test(navigator.userAgent);

  const mallReservedEncoded = useMemo(() => {
    const obj = {
      UNITCODE: sessionStorage.getItem("UNITCODE"),
      LOCKER_NO: sessionStorage.getItem("lockerNo"),
      LOCKER_TYPE: type,
      cost,
      mainCode: locationMainCode,
    };
    return encodeURIComponent(JSON.stringify(obj));
  }, [type, cost, locationMainCode]);

  const ReturnUrl = `${window.location.origin}/api/smartropay/mobile_approvePayment?MallReserved=${mallReservedEncoded}`;
  const StopUrl = `${window.location.origin}/Payment?cancel=1`;

  useEffect(() => {

    const savedLang = localStorage.getItem("lang");
    if (savedLang) setTmpLang(savedLang);

  }, []);

  if (locationMainCode && locationLockerNo) {
    sessionStorage.setItem("mainCode", locationMainCode);
    sessionStorage.setItem("lockerNo", locationLockerNo);
  }

// 초과 요금 조회 추가 로직
useEffect(() => {
  if (locationMainCode === "F") {
	const unitcode = sessionStorage.getItem("UNITCODE");
	const lockerNo = sessionStorage.getItem("lockerNo");
	if (!unitcode || !lockerNo) return;

	fetch("/api/overageFeeApi", {
	  method: "POST",
	  headers: { "Content-Type": "application/json" },
	  body: JSON.stringify({ unitcode, lockerNo: parseInt(lockerNo) }),
	})
	  .then(res => res.json())
	  .then(data => {
		console.log("overageFeeApi 응답:", data); 
		if (data.success) {
		  setCost(data.overageFee);
		  setStartTime(data.startTime);
		  setEndTime(data.endTime);
  			 sessionStorage.setItem("phoneNumber", data.phoneNumber);

		  if (data.phoneNumber) {
  			 sessionStorage.setItem("phoneNumber", data.phoneNumber);
		  }

		  if (data.overageFee === 0) {
			navigate("/LockerProcessing", {
			  state: {
				mainCode: locationMainCode,
				lockerNo: locationLockerNo,
				type: "초과요금 없음",
				startTime: data.startTime,
				endTime: data.endTime,
				logId,
				cost: data.overageFee,
			  },
			});
		  }
		} else {
			alert(t("overage_fee_fetch_failed"));
		}
	  })
	  .catch(err => {
		console.error("초과 요금 오류:", err);
		//alert("서버 오류 발생");
	  });
  }
}, [locationMainCode]);


  useEffect(() => {
    const script = document.createElement("script");
    const today = new Date().toISOString().slice(0, 10).replace(/-/g, "");
    //const domain = isMobile ? "https://tmpay.smartropay.co.kr" : "https://tpay.smartropay.co.kr";  테스트모드
    const domain = isMobile ? "https://mpay.smartropay.co.kr" : "https://pay.smartropay.co.kr";
    script.src = `${domain}/asset/js/SmartroPAY-1.0.min.js?version=${today}`;
    script.onload = () => setSdkLoaded(true);
    script.onerror = () => console.error("SDK 로드 실패");
    document.head.appendChild(script);
    return () => document.head.removeChild(script);
  }, [isMobile]);


  useEffect(() => {
    const unitcode = sessionStorage.getItem("UNITCODE");
    const lockerNo = sessionStorage.getItem("lockerNo");
    const ratesType = sessionStorage.getItem("RatesTYPE");
    const dayType = sessionStorage.getItem("DayType");

    if (unitcode && lockerNo) {
      fetch("/api/lockerboxpayset", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ unitcode, lockerNo: parseInt(lockerNo) }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data && data.length > 0) {
            const setup = data[0];
            setFeeData(setup);

			const types = [];

			// 일반결제는 요금만 체크
			if (setup.BASE_PAY >= 0 && dayType !== "N") types.push("일반결제");
			// 주간결제는 요금이 있고 ratesType이 "W"일 때만
			if (setup.WEEK_BASE_PAY >= 0 && ratesType === "W") types.push("주간결제");
			// 장기결제는 요금이 있고 ratesType이 "M"일 때만
			if (setup.MONTH_BASE_PAY >= 0 && ratesType === "M") types.push("장기결제");

			setAvailableTypes(types);
			if (types.length > 0) setType(types[0]);

			const isFree = types.length === 0;

			if (types.length === 0 && locationMainCode !== "F") {

			  const nowKST = getKSTDate(); // 현재  시간
			  let endKST = new Date(nowKST); // 종료 시간 초기화
			  const baseHour = parseInt(setup.BASE_HOUR);

			  if (!baseHour || isNaN(baseHour) || baseHour === 0) {
				endKST.setFullYear(endKST.getFullYear() + 5);
			  } else {
				endKST.setHours(endKST.getHours() + baseHour); // BASE_HOUR 만큼 더함
			  }

			  const formatToMSSQLDatetime = (date) => {
				const pad = (n) => String(n).padStart(2, "0");
				return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}.000`;
			  };

			  const formattedStart = formatToMSSQLDatetime(nowKST);
			  const formattedEnd = formatToMSSQLDatetime(endKST);

              navigate("/LockerProcessing", {
                state: { 
					mainCode: locationMainCode, 
					lockerNo: locationLockerNo, 
					type: "무료이용", 
					startTime: formattedStart,
					endTime: formattedEnd,
					logId
				},
              });
            }
          }
        });
    }
  }, []);

useEffect(() => {
  if (!feeData) return;

  const mainCode = sessionStorage.getItem("mainCode");
  if (mainCode === "F") return; // 초과요금이면 요금 계산 무시

  const now = new Date();
  const end = new Date(now);

  const getFormatted = (date) =>
    `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(
      date.getDate()
    ).padStart(2, "0")} ${String(date.getHours()).padStart(2, "0")}:${String(
      date.getMinutes()
    ).padStart(2, "0")}:${String(date.getSeconds()).padStart(2, "0")}`;

  let total = 0;

  if (type === "일반결제") {
    const h = feeData.BASE_HOUR;
    let r = h;
    total += feeData.BASE_PAY;
    r -= feeData.BASE_HOUR;

    if (feeData.APPEND1_HOUR > 0 && r > 0) {
      total += feeData.APPEND1_PAY;
      r -= feeData.APPEND1_HOUR;
    }
    if (feeData.APPEND2_HOUR > 0 && r > 0) {
      total += feeData.APPEND2_PAY;
      r -= feeData.APPEND2_HOUR;
    }

    if (h > 0) {
      end.setHours(end.getHours() + h); // BASE_HOUR 있을 때
    } else {
      end.setFullYear(end.getFullYear() + 5); // 없으면 5년 뒤
    }

  } else if (type === "주간결제") {
    total = feeData.WEEK_BASE_PAY * weeks;
    end.setDate(end.getDate() + weeks * 7);
  } else if (type === "장기결제") {
    total = feeData.MONTH_BASE_PAY * months;
    end.setDate(end.getDate() + months * 30);
  }

  setStartTime(getFormatted(now));
  setEndTime(getFormatted(end));
  setCost(total);

  console.log(`setStartTime1:${startTime}`);
}, [type, months, weeks, feeData]);

  const getMoid = () => {
    const now = new Date();
    const y = now.getFullYear();
    const M = String(now.getMonth() + 1).padStart(2, '0');
    const d = String(now.getDate()).padStart(2, '0');
    const h = String(now.getHours()).padStart(2, '0');
    const m = String(now.getMinutes()).padStart(2, '0');
    const s = String(now.getSeconds()).padStart(2, '0');
    const ms = String(now.getMilliseconds()).padStart(3, '0');
    const lockerNo = sessionStorage.getItem('lockerNo');
    return `Moid_${y}${M}${d}${h}${m}${s}${ms}_${lockerNo}`;
  };
  const getBuyerTel = sessionStorage.getItem("phoneNumber");

  useEffect(() => {
    if (cost <= 0) return;
    const UNITCODE = sessionStorage.getItem("UNITCODE"); 
    fetch("/api/smartropay/get-encrypt-data", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ Amt: cost, UNITCODE }),
    })
      .then((res) => res.json())
      .then((data) => {

		  if (!data || !data.EncryptData || !data.EdiDate) {
			alert("해쉬값을 불러오지 못했습니다. 다시 시도해주세요.");
			return;
		  }

        setMid(data.mid);
        setEncryptData(data.EncryptData);
        setEdiDate(data.EdiDate);
      });
  }, [cost]);

  const handlePayment = () => {

	//  결제 금액이 0이면 Smartropay 호출 없이 바로 이동
	if ((type === "일반결제" || type === "장기결제" || type === "주간결제") && cost === 0) {
		sessionStorage.setItem("locker_return_type", type);
		sessionStorage.setItem("locker_return_startTime", startTime);
		sessionStorage.setItem("locker_return_endTime", endTime);
		sessionStorage.setItem("locker_return_cost", cost.toString());
		sessionStorage.setItem("locker_return_logId", logId);
		localStorage.setItem("locker_return_startTime", startTime);
		localStorage.setItem("locker_return_endTime", endTime);

		navigate("/LockerProcessing", {
		  state: {
			mainCode: locationMainCode,
			lockerNo: locationLockerNo,
			type,
			startTime,
			endTime,
			logId,
			cost,
		  },
		});
		return; // 여기서 종료 → 아래 Smartro 로직 실행 X
	  }

    if (!selectedMethod) return alert(t("please_select_payment_method"));
    if (!sdkLoaded || !encryptData) return alert(t("loading_payment_sdk"));

    sessionStorage.setItem("locker_return_type", type);
    sessionStorage.setItem("locker_return_startTime", startTime);
    sessionStorage.setItem("locker_return_endTime", endTime);
    sessionStorage.setItem("locker_return_cost", cost.toString());
    sessionStorage.setItem("locker_return_logId", logId);
		localStorage.setItem("locker_return_startTime", startTime);
		localStorage.setItem("locker_return_endTime", endTime);

    console.log(`start1:${startTime}`);
    //window.smartropay.init({ mode: "STG" }); //테스트모드
    window.smartropay.init({ mode: "REAL" });
    const paymentParams = isMobile
  ? {
      FormId: "tranMgr",
      Mid,
      Amt: cost,
      Moid: getMoid(),
      PayMethod: selectedMethod,
      ReturnUrl,
      StopUrl,
      GoodsName: locationMainCode === "F" ? "무인보관함(초과금액)" : "무인보관함",
      BuyerName: getBuyerTel,
      BuyerTel: getBuyerTel,
      EncryptData: encryptData,
      EdiDate: ediDate,
      Language: tmpLang,
    }
  : {
      FormId: "tranMgr",
      Callback: async (res) => {
        console.log("결제 Callback 수신:", res);
        console.log(`start2:${startTime}`);
        if (res?.Tid && res?.TrAuthKey) {
          try {
            const response = await fetch("/api/smartropay/approve-payment", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                Tid: res.Tid,
                TrAuthKey: res.TrAuthKey,
                UNITCODE: sessionStorage.getItem("UNITCODE"),
                mainCode: locationMainCode,
                LOCKER_NO: sessionStorage.getItem("lockerNo"),
                LOCKER_TYPE: type,
                LogId: logId,
                cost,
              }),
            });

            const data = await response.json();

            const {
              ResultCode, ResultMsg, AppCardCode
            } = data.result;

            //console.log(`ResultCode:${data?.ResultCode}, ${JSON.stringify(data)}, ${successCodes.includes(data.ResultCode)}`);
            //console.log(`cardCode:${data?.AppCardCode} ${ResultCode} ${ResultMsg} ${AppCardCode} ${data.success}`);
            if (ResultCode && successCodes.includes(ResultCode)) {

              //console.log(`navigate to LockerProcessing : ${locationMainCode} ${locationLockerNo} `);
              navigate("/LockerProcessing", {
                state: {
                  mainCode: locationMainCode,
                  lockerNo: locationLockerNo,
                  type,
                  startTime,
                  endTime,
                  logId,
                  cost,
                  resultCode: ResultCode,
                  cardCode: AppCardCode || ''
                },
              });

            /*   navigate("/Payment?cancel=1");*/
            } else {
         /*      navigate("/LockerProcessing", {
                state: {
                  mainCode: locationMainCode,
                  lockerNo: locationLockerNo,
                  type,
                  startTime,
                  endTime,
                  logId,
                  cost,
                },
              });*/

              navigate("/Payment?cancel=1");
            }
          } catch (err) {
            console.error("결제 승인 실패:", err);
            alert(t("payment_approval_error"));
            navigate("/Payment?cancel=1");
          }
        } else {
          alert(t("payment_cancel_or_fail"));
          navigate("/Payment?cancel=1");
        }
      },
    };

    window.smartropay.payment(paymentParams);
  };


  // 초과 시간 계산
const getOverageDuration = () => {
  if (locationMainCode !== "F" || !startTime || !endTime) return "";

  const parseKSTDate = (str) => {
    // "YYYY-MM-DD HH:mm:ss" 형태 문자열 -> KST Date
    const [datePart, timePart] = str.split(" ");
    const [year, month, day] = datePart.split("-").map(Number);
    const [hour, minute, second] = timePart.split(":").map(Number);
    return new Date(year, month - 1, day, hour, minute, second);
  };

  const start = parseKSTDate(startTime);
  const end = parseKSTDate(endTime);

  const diffMs = end - start;
  const totalMinutes = Math.floor(diffMs / (1000 * 60));
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return `${hours}${t("hour_unit")} ${minutes}${t("minute_unit")}`;
};

  return (
    <div className="wrap">
      <header>
        <div className="title" onClick={() => navigate("/")}>
          <h1 dangerouslySetInnerHTML={{ __html: t("confirm_payment_info") }} />
        </div>
        <button className="back-button" onClick={() => window.history.back()}>←</button>
      </header>

      <div className="payment-info">
        <div className="payment-info-box">
          <h2>{t("payment_info")}</h2>
          <div className="dashed-line" />
          <div className="payinfo-columns">
            <div className="paycolumn">
              <div className="paylabel">{locationMainCode === "F" ? t("overage_time") : t("start_time")}</div>
              <div className="payvalue">{startTime}</div>
              <div className="payvalue">{endTime}</div>
              {locationMainCode === "F" && <div className="payvalue">{t("total_overage_time")}: {getOverageDuration()}</div>}
            </div>
            <div className="paycolumn">
              <div className="paylabel">{t("payment_type")}</div>
              <div className="payvalue">
                {locationMainCode === "F" && type === "일반결제"
                  ? t("extra_payment")
                  : t(type === "일반결제" ? "standard_payment" : type === "주간결제" ? "weekly_payment" : type === "장기결제" ? "monthly_payment" : type)}
              </div>
              {type === '장기결제' && <div className="payvalue">{t("month_label")}: {months}{t("month_unit")}</div>}
              {type === '주간결제' && <div className="payvalue">{t("week_label")}: {weeks}{t("week_unit")}</div>}
            </div>
          </div>
        </div>
      </div>

	<div className="payment-type-tab">
	  {locationMainCode === "F" ? (
		<button className="tab-btn active">
		  {t("extra_payment")}
		  <div className="tab-underline" />
		</button>
	  ) : (
		availableTypes.map((item) => (
		  <button
			key={item}
			className={`tab-btn ${type === item ? 'active' : ''}`}
			onClick={() => setType(item)}
		  >
			{t(
			  item === "일반결제"
				? "standard_payment"
				: item === "주간결제"
				? "weekly_payment"
				: item === "장기결제"
				? "monthly_payment"
				: item
			)}
			{type === item && <div className="tab-underline" />}
		  </button>
		))
	  )}
	</div>

      <main className="content" style={{ border: 0 }}>
        {type === "장기결제" && (
          <div className="months-select">
            <label>{t("select_month_count")}</label>
            <select value={months} onChange={(e) => setMonths(+e.target.value)}>
              {MONTH_OPTIONS.map((m) => <option key={m} value={m}>{m}{t("month_unit")}</option>)}
            </select>
          </div>
        )}
        {type === "주간결제" && (
          <div className="weeks-select">
            <label>{t("select_week_count")}</label>
            <select value={weeks} onChange={(e) => setWeeks(+e.target.value)}>
              {WEEK_OPTIONS.map((w) => <option key={w} value={w}>{w}{t("week_unit")}</option>)}
            </select>
          </div>
        )}


        <div className="short-term-fee">
			<strong>{locationMainCode === "F" ? t("overage_fee") : t("usage_fee")}:</strong> {cost.toLocaleString()}{t("currency_unit")}
        </div>

		{cost > 0 && (
		  <div className="payment-methods">
			<h3>{t("select_payment_method")}</h3>
			<div className="methods-grid">
			  {PAYMENT_METHODS.map(({ label, value }) => (
				<button key={value} className={`method-card ${selectedMethod === value ? 'selected' : ''}`} onClick={() => setSelectedMethod(value)}>
				  {label}
				</button>
			  ))}
			</div>
		  </div>
		)}

        {locationMainCode !== "F" && feeData && (
          <div className="fee-info-box">
            <h3>{t("fee_details", { type })}</h3>
            <div className="dashed-line" />
            <div className="fee-columns">
              {type === "일반결제" && (
                <>
                  <div className="fee-row"><span className="fee-label">{t("base_time")}</span><span className="fee-value">{feeData.BASE_HOUR}{t("hour_unit")} / {feeData.BASE_PAY.toLocaleString()}{t("currency_unit")}</span></div>
                  {feeData.APPEND1_PAY > 0 && feeData.APPEND1_HOUR > 0 && 
				<div className="fee-row">
					<span className="fee-label">{t("extra_fee1")}</span>
					<span className="fee-value">{feeData.BASE_HOUR}{t("hour_unit")}~ {feeData.BASE_HOUR+feeData.APPEND1_HOUR}{t("hour_unit")} / {feeData.APPEND1_PAY.toLocaleString()}{t("currency_unit")}</span>
				</div>}
                  {feeData.APPEND2_PAY > 0 && feeData.APPEND2_HOUR > 0 && 
					  <div className="fee-row">
					<span className="fee-label">{t("extra_fee2")}</span>
					<span className="fee-value">{feeData.BASE_HOUR + feeData.APPEND1_HOUR}{t("hour_unit")}~ {feeData.BASE_HOUR + feeData.APPEND1_HOUR + feeData.APPEND2_HOUR}{t("hour_unit")} / {feeData.APPEND2_PAY.toLocaleString()}{t("currency_unit")}</span>
                  </div>}
					{parseInt(feeData.BASE_PAY) > 0 &&
					 parseInt(feeData.BASE_HOUR) > 0 &&
					 parseInt(feeData.REPEAT_HOUR) > 0 &&
					 parseInt(feeData.REPEAT_PAY) > 0 && (
                      <div className="fee-row">
                        <span className="fee-label">{t("repeat_fee")}</span>
                        <span className="fee-value">
                          {parseInt(feeData.APPEND1_PAY) > 0 && parseInt(feeData.APPEND1_HOUR) > 0  || parseInt(feeData.APPEND2_PAY) > 0 && parseInt(feeData.APPEND2_HOUR) > 0
							? `${feeData.BASE_HOUR + feeData.APPEND1_HOUR + feeData.APPEND2_HOUR}${t("hour_unit")} `
                            : ""}
                          {feeData.REPEAT_HOUR}{t("hour_unit")} {feeData.REPEAT_PAY.toLocaleString()}{t("currency_unit")}
                        </span>
                      </div>
					)}
                </>
              )}
              {type === "주간결제" && (
                <>
                  <div className="fee-row"><span className="fee-label">{t("base_fee")}</span><span className="fee-value">{feeData.WEEK_BASE_PAY.toLocaleString()}{t("currency_unit")}</span></div>
                  {feeData.WEEK_REPEAT_PAY > 0 && 
					<div className="fee-row"><span className="fee-label">{t("week_over_fee")}</span><span className="fee-value">+{feeData.WEEK_REPEAT_PAY.toLocaleString()}{t("currency_unit")}</span></div>
                  }
                </>
              )}
              {type === "장기결제" && (
                <>
                  <div className="fee-row"><span className="fee-label">{t("base_fee")}</span><span className="fee-value">{feeData.MONTH_BASE_PAY.toLocaleString()}{t("currency_unit")}</span></div>
                  {feeData.MONTH_REPEAT_PAY > 0 && 
					<div className="fee-row"><span className="fee-label">{t("month_over_fee")}</span><span className="fee-value">+{feeData.MONTH_REPEAT_PAY.toLocaleString()}{t("currency_unit")}</span></div>
                  }
                </>
              )}
            </div>
          </div>
        )}

		{locationMainCode === "F" && (
		  <div className="fee-info-box">
			<div className="dashed-line" />
			<div className="fee-columns">
			  <div className="fee-row">
				<span className="fee-label">{t("overage_fee")}</span>
				<span className="fee-value">{cost.toLocaleString()}{t("currency_unit")}</span>
			  </div>
			</div>
		  </div>
		)}

        <button className="pay-button" onClick={handlePayment} >{t("pay_now")}</button>
      </main>

      <form id="tranMgr" name="tranMgr" method="post" style={{ display: "none" }}>
        <input type="text" name="PayMethod" defaultValue={selectedMethod} />
        <input type="text" name="GoodsCnt" defaultValue="1" />
        <input type="text" name="GoodsName" defaultValue={locationMainCode === "F" ? "무인보관함(초과금액)" : "무인보관함"} />
        <input type="text" name="Amt" value={cost} />
        <input type="text" name="Moid" defaultValue={getMoid()} />
        <input type="text" name="Mid" value={Mid} />
        <input type="text" name="ReturnUrl" value={ReturnUrl} />
        <input type="text" name="StopUrl" value={StopUrl} />
        <input type="text" name="BuyerName" defaultValue={getBuyerTel} />
        <input type="text" name="BuyerTel" defaultValue={getBuyerTel} />
        <input type="text" name="BuyerEmail" defaultValue="" />
        <input type="text" name="EncryptData" defaultValue={encryptData} />
        <input type="text" name="EdiDate" defaultValue={ediDate} />
        <input type="text" name="Language" value={tmpLang} />
        <input type="text" name="LogId" value={sessionStorage.getItem("logId")} />
        <input type="text" name="UNITCODE" value={sessionStorage.getItem("UNITCODE")} />
        <input type="text" name="LOCKER_NO" value={sessionStorage.getItem("lockerNo")} />
        <input type="text" name="LOCKER_TYPE" value={type} />
        <input type="text" name="mainCode" value={locationMainCode} />
      </form>

		<form id="approvalForm" name="approvalForm" method="post">
		  <input type="hidden" id="Tid" name="Tid"/>
		  <input type="hidden" id="TrAuthKey" name="TrAuthKey"/>
		</form>

		  {showPopup && (
			<CommonPopup
			  visible={true}
			  message={`${t("continue_question")}<br/><span style="font-weight:700;color:red">(${remainingSeconds} ${t("seconds")})</span>${t("auto_redirect")}`}
			  onConfirm={confirmRedirect}
			  onClose={cancelRedirect}
			  confirmText={t("yes")}
			  cancelText={t("no")}
			/>
		  )}

      <Footer />
    </div>
  );
};

export default Payment;
